'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteOverlay', ['$compile', 'Session', 'saNoteGlobalButtonHeightOffset', '$timeout', function ($compile, Session, saNoteGlobalButtonHeightOffset, $timeout) {
      function handleScreenResize() {
        var overlayHeight = $('.sa-note-overlay').height();
        var measuredHeight = lodash.sumBy($('.overlay-measure'), function(elem) { return $(elem).outerHeight(true); });

        $('.overlay-target').height(overlayHeight - measuredHeight - 30);
      }

      var template = '<div class="sa-note-overlay"><div id="sa-note-general-ui" sa-note-general-ui></div></div>';
      return {
        restrict: 'A',
        scope: {},
        link: function(scope, elem) {
          var uiExists = false;

          scope.$on('note-overlay-open', function(event, args) {
            if (!uiExists) {
              uiExists = true;
              $(elem).html($compile(template)(scope))
            }

            $timeout(function() {
              $('body').addClass('note-overlay-open');
              $(elem).first().children().first().addClass('open');

              if (args && args.action == 'expand-create') {
                scope.$broadcast('focus-sa-note-create');
              } else {
                handleScreenResize();
              }
            }, 150);
          });

          scope.$on('note-overlay-close', function (event) {
            $('body').removeClass('note-overlay-open');
            $(elem).first().children().first().removeClass('open');
          });

          scope.$on('sa-note-create-expanded', function() {
            $timeout(handleScreenResize, 250);
          });
        }
      };
    }]);
